import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { type OfferRow, api } from "../lib/api";
import { OfferForm, type OfferFormValues, updateOffer } from "./OfferForm";

function toFormValues(o: OfferRow): OfferFormValues {
	const geos = (() => {
		try {
			const v = JSON.parse(o.geos);
			return Array.isArray(v) ? (v as string[]).join(",") : "";
		} catch {
			return "";
		}
	})();
	let minVolume = "0";
	try {
		const dsl = JSON.parse(o.constraintsDsl) as { minMonthlyVolume?: number };
		if (typeof dsl.minMonthlyVolume === "number") minVolume = String(dsl.minMonthlyVolume);
	} catch {
		/* leave default */
	}
	return {
		title: o.title,
		vertical: o.vertical,
		payoutType: o.payoutType === "hybrid" ? "cpa" : o.payoutType,
		payoutAmount: String(o.payoutAmount ?? o.payoutPercent ?? 0),
		geos,
		minVolume,
	};
}

export function OfferEdit() {
	const { id = "" } = useParams();
	const nav = useNavigate();
	const { data, isLoading, error } = useQuery<OfferRow>({
		queryKey: ["offer", id],
		queryFn: () => api.get(`/offers/${id}`),
		enabled: !!id,
	});

	if (isLoading) return <div className="p-6">Loading…</div>;
	if (error) return <div className="p-6 text-red-700">Error: {(error as Error).message}</div>;
	if (!data) return <div className="p-6">Not found</div>;

	return (
		<div className="p-6">
			<h1 className="mb-4 text-xl font-semibold">Edit offer</h1>
			<OfferForm
				initial={toFormValues(data)}
				submitLabel="Save"
				onSubmit={async (v) => {
					await updateOffer(id, v);
					nav(`/offers/${id}`, { replace: true });
				}}
				onCancel={() => nav(`/offers/${id}`)}
			/>
		</div>
	);
}
